import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Gallery.css';
import config from '../../config'; 
function Gallery() {
  const [galleryImages, setGalleryImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageType, setSelectedImageType] = useState(null);
  const [wrongMark, setWrongMark] = useState(false);
  const [filter, setFilter] = useState('All');
  const [currentPlayingVideo, setCurrentPlayingVideo] = useState(null); // Track current playing video
  const [loading, setLoading] = useState(true); // Track loading state
  const [error, setError] = useState(null); // Track error state

  useEffect(() => {
    setLoading(true); // Set loading state to true before fetching data
    setError(null); // Reset error state before fetching

    axios
      .get(`${config.backendUrl}/api/images?category=${filter}`)
      .then((response) => {
        setGalleryImages(response.data);
        setLoading(false); // Set loading state to false when data is fetched
      })
      .catch((error) => {
        console.error('Error fetching images:', error);
        setLoading(false); // Set loading state to false in case of an error
        setError('Failed to load images. Please try again later.');
      });
  }, [filter]);

  const handleImageClick = (item) => {
    setSelectedImage(item.media_url); // Set selected image or video URL
    setSelectedImageType(item.media_type); // Set type (photo or video)
    setWrongMark(true); // Logic for showing wrong mark (if applicable)
  };

  const closeFullscreen = () => {
    setSelectedImage(null);
    setSelectedImageType(null);
    setWrongMark(false);
  };

  const handleFilterChange = (category) => {
    setFilter(category); // Update the selected filter
  };

  const handleVideoClick = (videoRef) => {
    if (currentPlayingVideo && currentPlayingVideo !== videoRef) {
      currentPlayingVideo.pause(); // Pause the currently playing video
    }
    setCurrentPlayingVideo(videoRef); // Set the new video as the current playing one
  };

  return (
    <div className="gallery-container">
      <h1>Our Gallery</h1>

      {/* Filter Buttons */}
      <div className="filter-buttons">
        {['All', 'ISRO Show', 'Free English Speaking Class Photos', 'Free Cyber Security Session in Gov. School'].map(
          (category) => (
            <button
              key={category}
              className={`filter-btn ${filter === category ? 'selected' : ''}`}
              onClick={() => handleFilterChange(category)}
            >
              {category}
            </button>
          )
        )}
      </div>

      {/* Loading State */}
      {loading && <div className="loading-spinner">Loading...</div>}

      {/* Error State */}
      {error && <div className="error-message">{error}</div>}

      {/* Image Grid */}
      <div className="image-grid">
        {!loading && !error && galleryImages.length > 0 ? (
          galleryImages.map((item, index) => (
            <div key={index} className="image-item" onClick={() => handleImageClick(item)}>
              <div className="overlay">
                <i className="fas fa-arrows-alt"></i>
              </div>
              {item.media_type.toLowerCase() === 'photo' ? (
                <img src={item.media_url} alt={`Gallery ${index + 1}`} />
              ) : (
                <video
                  ref={(ref) => {
                    if (ref && currentPlayingVideo !== ref) {
                      ref.pause(); // Ensure video is paused when rendered
                    }
                  }}
                  width="320"
                  height="240"
                  controls
                  muted
                  onClick={(e) => handleVideoClick(e.target)}
                  onError={(e) => console.error(`Error loading video: ${e.target.src}`)}
                >
                  <source src={item.media_url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </div>
          ))
        ) : (
          !loading && <p>No media found</p>
        )}
      </div>

      {/* Fullscreen Modal */}
      {selectedImage && (
        <div className="fullscreen-overlay" onClick={closeFullscreen}>
          {selectedImageType.toLowerCase() === 'photo' ? (
            <img src={selectedImage} alt="Full Screen" className="fullscreen-image" />
          ) : (
            <video controls className="fullscreen-video">
              <source src={selectedImage} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
          {wrongMark && (
            <div className="wrong-mark">
              <i className="fas fa-times-circle"></i>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Gallery;
